module.exports = __webpack_public_path__ + "img/accent.04b17a40.png";